import { useEffect, useState } from 'react';

/**
 * A ticking clock that stays honest on a wall display left running for months.
 *
 * setInterval(1000) drifts and, worse, stalls entirely while a tablet sleeps — waking to a
 * clock that's minutes behind. Re-scheduling against the real time each tick self-corrects
 * both, and the visibility listener snaps it back the instant the screen wakes.
 */
export function useNow(intervalMs = 1000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timer: number;

    const tick = (): void => {
      setNow(new Date());
      const delay = intervalMs - (Date.now() % intervalMs);
      timer = window.setTimeout(tick, delay);
    };
    tick();

    const onVisible = (): void => {
      if (document.visibilityState === 'visible') setNow(new Date());
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);

  return now;
}
